import { Pagination } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface TablePaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

const TablePagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange
}: TablePaginationProps) => {
  const { t } = useTranslation("parts");
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  if (pageCount <= 1) {
    return null;
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const renderPaginationItems = () => {
    let items = [];
    for (let number = 1; number <= pageCount; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => onPageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    return <Pagination>{items}</Pagination>;
  };

  return (
    <div className="table-footer">
      <div className="pagination-info">
        {t("settings.showingOfToEntries", {from: startIndex + 1, to: endIndex, total: totalItems})}
      </div>
      <div className="pagination-container">{renderPaginationItems()}</div>
    </div>
  );
};

export default TablePagination;
